 function price_funs(price) {
        if (!price) return null;
        price = String(price);
        return price.slice(0, -2) + '.' + price.slice(-2);
    }


    function compareFn(number, name) {
        number === null ?
            name.css('display', 'none') :
            name.text(price_funs('$' + number));
    };

    function productImg(Dom, Class) {
        Dom.forEach((a, e) => {
            var haner = ''
            haner = "<div class='swiper-slide'><img class='img lazyload' src='' data-src='" + a + "'></div>"
            Class.append(haner)
        });
    }

    function addToCart(selectedVariantId) {
  if (!selectedVariantId) {
    console.error('No variant selected');
    return;
  }

  let formData = {
    items: [{
      id: selectedVariantId,
      quantity: 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => response.json())
    .then(data => {
      console.log('Added to cart:', data);

      // ✅ Impulse 官方 Cart Drawer 更新事件
    document.dispatchEvent(new CustomEvent('cart:build'));

    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
}


        (function () {
            var youtubeEls = document.querySelectorAll('.youtube');
            var currentPlaying = null;

            function createIframe(youtubeEl) {
                var iframe = document.createElement('iframe');
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow',
                    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                );
                iframe.setAttribute('allowfullscreen', '');
                iframe.setAttribute('src', 'https://www.youtube.com/embed/' + youtubeEl.dataset.embed +
                    '?rel=0&showinfo=0&autoplay=1&controls=1'); // 显示控件
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.position = 'absolute';
                iframe.style.top = '0';
                iframe.style.left = '0';
                iframe.style.objectFit = 'cover';
                return iframe;
            }

            function playVideo(youtubeEl) {
                if (currentPlaying && currentPlaying !== youtubeEl) {
                    stopVideo(currentPlaying);
                }
                if (!youtubeEl.querySelector('iframe')) {
                    var iframe = createIframe(youtubeEl);
                    youtubeEl.dataset.originalContent = youtubeEl.innerHTML; // 保存原始内容
                    youtubeEl.innerHTML = '';
                    youtubeEl.appendChild(iframe);
                    currentPlaying = youtubeEl;
                }
            }

            function stopVideo(youtubeEl) {
                if (youtubeEl.querySelector('iframe')) {
                    youtubeEl.innerHTML = youtubeEl.dataset.originalContent; // 恢复原始内容
                    currentPlaying = null;
                }
            }

            // 为每个 .youtube 元素绑定点击事件
            for (var i = 0; i < youtubeEls.length; i++) {
                youtubeEls[i].addEventListener('click', function () {
                    if (currentPlaying === this) {
                        // 如果当前元素已在播放，点击停止
                        stopVideo(this);
                        swiper[4].autoplay.start();

                    } else {
                        // 否则播放视频
                        playVideo(this);
                        swiper[4].autoplay.stop();

                    }
                });
            }
        })();